module.exports = __webpack_public_path__ + "c_static/img/poster.cf3e4a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/poster.png
// module id = joLQ
// module chunks = 33